<template>
  <div>
    <el-dialog title="积分获取明细" :visible.sync="gainDetailDialog" width="1000px">
      <el-select v-model="tableQuery.type"
                 placeholder="请选择"
                 size="small"
                 clearable @change="selectPage"
                 style="margin-bottom: 16px;width: 150px">
        <el-option label="获取明细" :value="0"/>
        <el-option label="兑换明细" :value="1"/>
      </el-select>
      <el-table border class="table" :data="tableData" size="mini"
                :cell-style="{padding:0+'px'}" height="400px" v-loading="tableQuery.loading" empty-text="空空如也～ ">
        <el-table-column prop="id" label="Id">
        </el-table-column>
        <el-table-column prop="name" label="名称">
        </el-table-column>
        <el-table-column prop="name" label="图片" width="100">
          <template #default="scope">
            <el-image v-if="scope.row.imageUrls!=null && scope.row.imageUrls.length>0" class="image"
                      :src="scope.row.imageUrls[0]" :preview-src-list="scope.row.imageUrls"></el-image>
            <div v-else class="image" style="margin-bottom: 6px"></div>
          </template>
        </el-table-column>
        <el-table-column label="积分明细">
          <template #default="scope">
            <el-tag type="danger">
              <span style="margin-right: 1px">{{scope.row.type ==0 ? '获取':'兑换'}}</span>
              <span style="margin:0 1px">{{scope.row.score}}</span>积分</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="获取时间">
        </el-table-column>
      </el-table>
      <el-pagination
          style="text-align: right;margin: 20px 10px"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="tableQuery.pageSize"
          @current-change="changePage"
          layout="total, prev, pager, next, jumper"
          :total="tableQuery.total">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {selectGainDetailByCoach} from '/src/api/contacts/hr/pointCard.js'
export default {
  name: "GainDetail",
  data() {
    return {
      tableData:[],
      tableQuery:{
        type:null,
        coachId:null,
        pageIndex:0,
        pageSize:10,
        loading:false
      },
      gainDetailDialog:false
    }
  },
  methods:{
    changePage(val){
      this.tableQuery.pageIndex = val;
      this.selectPage();
    },
    selectPage(){
      this.tableQuery.loading = true;
      selectGainDetailByCoach(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.status == 200){
          this.tableData = val.data.list;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    openDialog(coachId){
      this.gainDetailDialog = true;
      this.tableQuery.coachId = coachId;
      this.selectPage();
    }
  },
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
.image{
  width: 40px; height: 40px;background-color: #F2F6FC;margin-top: 6px;border-radius: 6px
}
</style>